import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';

import { Fieldset } from 'components/layout';
import { Descriptions } from 'components/common';


const PageDetail = ({ authToken, page, actions }) => {
  const detail = page.detail || {};

  return (
    <Row gutter={16}>
      <Col span={24}>
        <Fieldset>
          <Descriptions column={2} gutter={[16, 16]}>
            <Descriptions.Item label="Путь" span={24}>{detail?.path}</Descriptions.Item>
            <Descriptions.Item label="Тайтл" span={24}>{detail?.title}</Descriptions.Item>
            <Descriptions.Item label="Дескрипшен" span={24}>{detail?.description}</Descriptions.Item>
            <Descriptions.Item label="H1" span={12}>{detail?.h1}</Descriptions.Item>
            <Descriptions.Item label="H2" span={12}>{detail?.h1}</Descriptions.Item>
            <Descriptions.Item label="Описание" span={24}>{detail?.text}</Descriptions.Item>
          </Descriptions>
        </Fieldset>

        <Fieldset title="Ссылки">
          <Descriptions column={2} gutter={[16, 16]}>
            <Descriptions.Item label="Текст для ссылок" span={8}>{detail?.link_text}</Descriptions.Item>
          </Descriptions>
        </Fieldset>
      </Col>
    </Row>
  );
};

const mapState = state => ({
  page: state.page,
  authToken: state.auth.token,
});

const mapDispatch = dispatch => ({
  actions: {
    page: dispatch.page,
  }
});

export default connect(mapState, mapDispatch)(PageDetail);
